import { toAppError } from "../utils/appError";

export const SB="https://qimgostiseehdnvhmoph.supabase.co";
export const KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpbWdvc3Rpc2VlaGRudmhtb3BoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUwMTQ1NDgsImV4cCI6MjA5MDU5MDU0OH0.7upLxWR1OqwvIx71Z4pFHUU7BFswDvcOQE9edjcL2yg";

const ah=t=>({
  apikey: KEY,
  Authorization: `Bearer ${t || KEY}`,
  "Content-Type": "application/json",
  Prefer: "return=representation"
});

const api=async(m,p,t,b)=>{
  let r;
  try{
    r=await fetch(`${SB}${p}`,{
      method:m,
      headers:ah(t),
      body:b?JSON.stringify(b):undefined
    });
  }catch(error){
    throw toAppError(error,{
      fallback:"서버에 연결하지 못했습니다. 인터넷 연결을 확인한 후 다시 시도해 주세요."
    });
  }

  try{
    const data = await r.json();
    return r.ok ? data : {...data, status:r.status, error:data?.error || data?.msg || data?.message || `http_${r.status}`};
  }catch(error){
    if(!r.ok){
      return {error:`http_${r.status}`,error_description:"요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.",status:r.status};
    }
    throw toAppError(error,{fallback:"서버 응답을 확인하지 못했습니다. 잠시 후 다시 시도해 주세요."});
  }
};

export const DB={
  signUp:async(e,pw,m,redirectTo,pkce={})=>{
    const result=await api("POST",`/auth/v1/signup${redirectTo?`?redirect_to=${encodeURIComponent(redirectTo)}`:""}`,null,{email:e,password:pw,data:m,...pkce});
    return result?.id && !result?.user && !result?.error ? {user:result} : result;
  },
  resendSignup:(e,redirectTo,pkce={})=>api("POST",`/auth/v1/resend${redirectTo?`?redirect_to=${encodeURIComponent(redirectTo)}`:""}`,null,{type:"signup",email:e,...pkce}),
  requestPasswordReset:(e,redirectTo,pkce={})=>api("POST",`/auth/v1/recover${redirectTo?`?redirect_to=${encodeURIComponent(redirectTo)}`:""}`,null,{email:e,...pkce}),
  signIn:(e,pw)=>api("POST","/auth/v1/token?grant_type=password",null,{email:e,password:pw}),
  exchangeSignupCode:(code,verifier)=>api("POST","/auth/v1/token?grant_type=pkce",null,{auth_code:code,code_verifier:verifier}),
  refreshSession:refreshToken=>api("POST","/auth/v1/token?grant_type=refresh_token",null,{refresh_token:refreshToken}),
  signOut:t=>fetch(`${SB}/auth/v1/logout`,{method:"POST",headers:ah(t)}),
  updateUser:(t,m)=>api("PUT","/auth/v1/user",t,{data:m}),
  updateProfile:(t,id,d)=>api("PATCH",`/rest/v1/profiles?id=eq.${id}`,t,d),
  getProfile:(t,id)=>api("GET",`/rest/v1/profiles?id=eq.${id}`,t),
  findProfileByEmail:e=>api("GET",`/rest/v1/profiles?email=eq.${encodeURIComponent(e)}`,KEY),
  list:(t,tb)=>api("GET",`/rest/v1/${tb}?order=created_at.asc`,t),
  query:(t,tb,qs)=>api("GET",`/rest/v1/${tb}?${qs}`,t),
  insert:(t,tb,d)=>api("POST",`/rest/v1/${tb}`,t,d),
  update:(t,tb,id,d)=>api("PATCH",`/rest/v1/${tb}?id=eq.${id}`,t,d),
  del:(t,tb,id)=>fetch(`${SB}/rest/v1/${tb}?id=eq.${id}`,{method:"DELETE",headers:ah(t)})
};


